module.exports = __webpack_public_path__ + "img/socio1.14f3fbb2.png";